import axios from 'axios'
import ConstList from '../ConstList'
import downloadFailure from '@/utils/downloadFailure'
import { downloadBlobResponse } from '../utils/fileDownload'

const PDF_ROUTE_CONFIGS = Object.freeze({
  '/admin/roster/list': Object.freeze({
    endpoint: '/admin/roster/pdf',
    label: '勤務表',
    targetUser: true
  }),
  '/admin/total/list': Object.freeze({
    endpoint: '/admin/total/pdf',
    label: '月次集計',
    targetUser: false
  }),
  '/admin/payoff/expenseList': Object.freeze({
    endpoint: '/admin/expense/pdf',
    label: '経費精算',
    targetUser: true
  }),
  '/admin/payoff/travelCostList': Object.freeze({
    endpoint: '/admin/commute/pdf',
    label: '通勤費精算',
    targetUser: true
  })
})

function normalizedRoutePath (routePath) {
  const path = String(routePath || '').trim().replace(/\/+$/, '')
  return path || '/'
}

function padMonth (month) {
  const value = Number(month)
  return Number.isInteger(value) && value >= 1 && value <= 12
    ? String(value).padStart(2, '0')
    : '00'
}

function yearMonthLabel (vm) {
  const year = String(vm && vm.year !== undefined ? vm.year : '').trim()
  return `${year || '対象年'}${padMonth(vm && vm.month)}`
}

function targetUserName (vm, userId) {
  if (!vm || !Array.isArray(vm.items)) return ''
  const target = vm.items.find(
    item => item && String(item.user_id) === String(userId)
  )
  return target ? String(target.user_name || '').trim() : ''
}

export function resolveLegacyPdfConfig (routePath) {
  return PDF_ROUTE_CONFIGS[normalizedRoutePath(routePath)] || null
}

export function buildLegacyPdfFallbackName (vm, config, userId) {
  const parts = [config.label, yearMonthLabel(vm)]
  if (config.targetUser) {
    const name = targetUserName(vm, userId)
    parts.push(name || `利用者${userId || ''}`)
  }
  return `${parts.filter(Boolean).join('_')}.pdf`
}

// 状態ごとの案内と記録は、売上管理・プロジェクト集計と共通。
// 対応表を2か所に持つと片方だけ直るので、utils/downloadFailure へ出した。
// ここは旧4帳票（勤務表・月次集計・経費・通勤費）用の事象名を与えるだけ。
const LEGACY_PDF_EVENT = 'LEGACY_PDF_DOWNLOAD_FAILED'

export const statusOf = downloadFailure.statusOf
export const messageForStatus = downloadFailure.messageForStatus
export const shouldReport = downloadFailure.shouldReport

export function describeFailure (error, status) {
  return downloadFailure.describeFailure(error, status, LEGACY_PDF_EVENT)
}

function defaultErrorReporter (http, error) {
  return downloadFailure.reportDownloadFailure(http, error, LEGACY_PDF_EVENT)
}

export function createLegacyPdfHandler (
  vm,
  config,
  dependencies = {}
) {
  const http = dependencies.http || axios
  const downloader = dependencies.downloader || downloadBlobResponse
  const errorReporter = dependencies.errorReporter || defaultErrorReporter

  return function legacyPdfDownload (userId) {
    const params = {
      year: vm.year,
      month: vm.month
    }
    if (config.targetUser) params.user_id = userId

    const fallbackFileName = buildLegacyPdfFallbackName(
      vm,
      config,
      userId
    )

    return http
      .get(
        `${process.env.VUE_APP_API_ORIGIN}${config.endpoint}`,
        { params, responseType: 'blob' }
      )
      .then(response => downloader(response, fallbackFileName))
      .catch(error => errorReporter(http, error))
  }
}

export function installLegacyPdfDownload (vm, dependencies = {}) {
  const routePath = vm && vm.$route ? vm.$route.path : ''
  const config = resolveLegacyPdfConfig(routePath)
  if (!config || !vm || typeof vm.openPDF !== 'function') return false
  if (vm.openPDF.__legacyPdfDownloadHandler) return true

  const handler = createLegacyPdfHandler(vm, config, dependencies)
  handler.__legacyPdfDownloadHandler = true
  vm.openPDF = handler
  return true
}

export default {
  created () {
    installLegacyPdfDownload(this)
  }
}
